<script>
  let top = Math.random() * 100;
  let right = Math.random() * 100;

  const animationDuration = 3000;

  let sizeOptions = [15, 25, 35];
  let size = sizeOptions[Math.floor(Math.random() * sizeOptions.length)];

  $: dynamicCssStyles = `--starting-right-pos: ${right}%; --starting-top-pos: ${top}%; --animation-duration: ${animationDuration}ms`;
</script>

<div
  class="star-container"
  style="top: {top}%; right: {right}%; {dynamicCssStyles}"
>
  <svg
    version="1.1"
    id="star"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 122.88 122.88"
    xml:space="preserve"
    preserveAspectRatio="xMidYMid"
    style="width: {size}px; height: {size}px;"
    ><g
      ><path
        class="star"
        d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z"
      /></g
    ></svg
  >
</div>

<style>
  svg {
    enable-background: new 0 0 122.88 122.88;
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: white;
  }

  .star-container {
    animation: moveToTop var(--animation-duration) forwards;
    animation-delay: 2000ms;
    position: absolute;
    z-index: 2;
    width: 35px;
    height: 35px;
    display: flex;
    place-items: center;
    justify-content: center;
    opacity: 0.5;
  }

  :global(.swiper-slide-active #star) {
    z-index: 4;
  }

  @keyframes moveToTop {
    0% {
      right: var(--starting-right-pos);
      top: var(--starting-top-pos);
    }

    100% {
      top: 0%;
      right: 0%;
      opacity: 1;
    }
  }

  /* @media screen and (max-width: 768px) {
    .star-container {
      animation: moveToBottom var(--animation-duration) forwards;
    }
  }

  @keyframes moveToBottom {
    0% {
      right: var(--starting-right-pos);
      top: var(--starting-top-pos);
    }

    100% {
      top: calc(100% - 3%);
      right: 20%;
      opacity: 1;
    }
  } */
</style>
